import {
  inventoryItemIdFormat,
  locationIdFormat,
} from "@redotech/redo-inventory-id";
import { productIdFormat } from "@redotech/redo-product-id";
import { storageLocationIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const getClosedOrderToteReturn = {
  name: "getClosedOrderToteReturn" as const,
  input: z.object({ fulfillmentGroupId: z.string() }),
  output: z.object({
    lines: z.array(
      z.object({
        lineId: z.string(),
        locationId: locationIdFormat.schema,
        productId: productIdFormat.schema,
        productTitle: z.string().nullable(),
        variantTitle: z.string().nullable(),
        sku: z.string().nullable(),
        imageUrl: z.string().nullable(),
        inventoryItemId: inventoryItemIdFormat.schema.nullable(),
        toteName: z.string(),
        toteStorageLocationId: storageLocationIdFormat.schema,
        sourceStorageLocationId: storageLocationIdFormat.schema,
        sourceBinName: z.string(),
        sourceBinReturnable: z.boolean(),
        quantity: z.number(),
      }),
    ),
  }),
};
